module.exports = __webpack_public_path__ + "static/marche-588b70cca9a93cb7b0019e91dd323c53.woff2";